/**
 * TUTARLARI GİZLE ve HAREKETSİZLİKTE PERDE (kullanıcı kararları 02.11.2026;
 * `claude/notlar/2026-11-02-perde-ve-tutar-gizleme-kararlar.md`).
 *
 * Tercihler YALNIZCA bu cihazın `localStorage`ında durur (tema gibi bir
 * sunum tercihi): kasaya ve merkeze yazılmaz.
 *
 *  - Gizliyken para tutarları ve miktarlar "•••" yazılır (`formatDecimal`);
 *    yüzdeler ve adlar görünür. Maske bir anormallik değildir.
 *  - "Kasa açılınca gizle": parolayla / kurtarma ifadesiyle açılışta gizli
 *    gelir. Oturum içinde yeniden yükleme açılış değildir: o anki hâl kalır.
 *  - "Perde inince gizle": perde her indiğinde gizlenir.
 *  - Perde süresi: Kapalı / 60 / 90 / 120 / 300 sn, varsayılan 60.
 */

import { useSyncExternalStore } from "react";
import { YEREL } from "../dil";

export const MASKE = "•••";

const GIZLI_ANAHTARI = "parafon.tutarlarGizli";
export const ACILISTA_GIZLE_ANAHTARI = "parafon.acilistaTutarGizle";
export const PERDEDE_GIZLE_ANAHTARI = "parafon.perdedeTutarGizle";
export const PERDE_SURESI_ANAHTARI = "parafon.perdeSuresiSn";

export const PERDE_SURELERI_SN = [0, 60, 90, 120, 300] as const;
export type PerdeSuresiSn = (typeof PERDE_SURELERI_SN)[number];
export const VARSAYILAN_PERDE_SURESI_SN: PerdeSuresiSn = 60;

function oku(anahtar: string): string | null {
  try {
    return globalThis.localStorage?.getItem(anahtar) ?? null;
  } catch {
    return null;
  }
}

function yaz(anahtar: string, deger: string): void {
  try {
    globalThis.localStorage?.setItem(anahtar, deger);
  } catch {
    /* depolama kapalıysa tercih bu sekmede geçerli kalır */
  }
}

let gizli = oku(GIZLI_ANAHTARI) === "1";
const dinleyiciler = new Set<() => void>();

export function tutarlarGizliMi(): boolean {
  return gizli;
}

export function tutarlariGizle(deger: boolean): void {
  yaz(GIZLI_ANAHTARI, deger ? "1" : "0");
  if (gizli === deger) return;
  gizli = deger;
  for (const d of dinleyiciler) d();
}

function abone(d: () => void): () => void {
  dinleyiciler.add(d);
  return () => dinleyiciler.delete(d);
}

export function useTutarlarGizli(): boolean {
  return useSyncExternalStore(abone, tutarlarGizliMi);
}

export function secenekAcik(anahtar: typeof ACILISTA_GIZLE_ANAHTARI | typeof PERDEDE_GIZLE_ANAHTARI): boolean {
  return oku(anahtar) === "1";
}

export function secenekYaz(anahtar: typeof ACILISTA_GIZLE_ANAHTARI | typeof PERDEDE_GIZLE_ANAHTARI, acik: boolean): void {
  yaz(anahtar, acik ? "1" : "0");
}

/** Parolayla ya da kurtarma ifadesiyle açılışta (kilit ekranı) çağrılır. */
export function acilistaGizlemeyiUygula(): void {
  if (secenekAcik(ACILISTA_GIZLE_ANAHTARI)) tutarlariGizle(true);
}

/** Perde her indiğinde çağrılır. */
export function perdedeGizlemeyiUygula(): void {
  if (secenekAcik(PERDEDE_GIZLE_ANAHTARI)) tutarlariGizle(true);
}

export function perdeSuresi(): PerdeSuresiSn {
  const ham = oku(PERDE_SURESI_ANAHTARI);
  const n = Number(ham);
  return ham !== null && (PERDE_SURELERI_SN as readonly number[]).includes(n) ? (n as PerdeSuresiSn) : VARSAYILAN_PERDE_SURESI_SN;
}

export function perdeSuresiYaz(sn: PerdeSuresiSn): void {
  yaz(PERDE_SURESI_ANAHTARI, String(sn));
}

/** Grafik tutar ekseni: yalnızca kılavuz, kısaltılmış; gizliyken maske. */
export function eksenTutar(n: number): string {
  if (gizli) return MASKE;
  return new Intl.NumberFormat(YEREL, { notation: "compact", maximumFractionDigits: 1 }).format(n);
}
